import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useRef, useState } from "react";
import { FcInfo } from "react-icons/fc";
var ArchivedTooltip = function(param) {
    var messaging = param.messaging;
    var nodeRef = useRef(null);
    var ref = useState(false), showMessage = ref[0], setShowMessage = ref[1];
    useEffect(function() {
        document.addEventListener("mousedown", handleMessageDisplay);
        document.addEventListener("mouseover", handleMessageDisplay);
        return function() {
            document.removeEventListener("mousedown", handleMessageDisplay);
            document.removeEventListener("mouseover", handleMessageDisplay);
        };
    }, []);
    var handleMessageDisplay = function(event) {
        if (nodeRef.current.contains(event.target)) {
            setShowMessage(true);
        } else {
            setShowMessage(false);
        }
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: "relative",
        ref: nodeRef,
        children: [
            /*#__PURE__*/ _jsx("span", {
                children: /*#__PURE__*/ _jsx(FcInfo, {
                    size: 24
                })
            }),
            showMessage && messaging && /*#__PURE__*/ _jsx("div", {
                className: "p-4 w-300p absolute z-50 bg-white max-h-72 py-4 border-black-400 border-2 border-l",
                children: /*#__PURE__*/ _jsx("div", {
                    dangerouslySetInnerHTML: {
                        __html: messaging
                    }
                })
            })
        ]
    });
};
export default ArchivedTooltip;
